var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8125 0H7.1875C3.21795 0 0 3.21795 0 7.1875V38.8125C0 42.782 3.21795 46 7.1875 46H38.8125C42.782 46 46 42.782 46 38.8125V7.1875C46 3.21795 42.782 0 38.8125 0Z",
    fill: "#58C5C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9999 7.1875V38.8125C46.0011 39.7565 45.8157 40.6915 45.4545 41.5637C45.0932 42.4359 44.5632 43.2282 43.8949 43.895L2.10498 2.10504C2.77175 1.43672 3.56399 0.906705 4.43619 0.545457C5.3084 0.18421 6.24338 -0.00115675 7.18744 5.4311e-06H38.8124C40.7187 5.4311e-06 42.5468 0.757258 43.8948 2.10517C45.2427 3.45309 45.9999 5.28126 45.9999 7.1875Z",
    fill: "#F9E600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6346 23.8399L10.0589 29.4156H10.0585L0 19.3567V8.20532L15.6346 23.8399Z",
    fill: "#338ECD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4162 10.0585L23.8405 15.6342L8.2063 0H19.3577L29.4162 10.0585Z",
    fill: "#842B7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8405 15.6328L15.6328 23.84L0 8.20543V7.1875C0 5.28125 0.757252 3.45309 2.10517 2.10517C3.45309 0.757252 5.28125 0 7.1875 0L8.20632 0L23.8405 15.6328Z",
    fill: "#6559A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8401 15.6345L29.4158 10.0588L46 26.6431V37.7945L23.8401 15.6345Z",
    fill: "#FDC017"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0583 29.4156L15.6341 23.8403L37.7936 45.9998H26.6422L10.0583 29.4156Z",
    fill: "#C8202D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6328 23.8405L23.84 15.6328L46 37.7946V38.8125C46 40.7187 45.2427 42.5469 43.8948 43.8948C42.5469 45.2427 40.7187 46 38.8125 46H37.7937L15.6328 23.8405Z",
    fill: "#D06D2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.0001 42.1911C32.131 42.1911 39.5331 34.789 39.5331 25.658C39.5331 16.5271 32.131 9.125 23.0001 9.125C13.8691 9.125 6.46704 16.5271 6.46704 25.658C6.46704 34.789 13.8691 42.1911 23.0001 42.1911Z",
    fill: "#323F53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 39.5329C32.131 39.5329 39.5331 32.1308 39.5331 22.9998C39.5331 13.8689 32.131 6.4668 23.0001 6.4668C13.8691 6.4668 6.46704 13.8689 6.46704 22.9998C6.46704 32.1308 13.8691 39.5329 23.0001 39.5329Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23 38.012C31.2909 38.012 38.012 31.2909 38.012 23C38.012 14.7091 31.2909 7.98804 23 7.98804C14.7091 7.98804 7.98804 14.7091 7.98804 23C7.98804 31.2909 14.7091 38.012 23 38.012Z",
    fill: "#323F53"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23 36.4707C30.4397 36.4707 36.4707 30.4397 36.4707 23C36.4707 15.5603 30.4397 9.5293 23 9.5293C15.5603 9.5293 9.5293 15.5603 9.5293 23C9.5293 30.4397 15.5603 36.4707 23 36.4707Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34.0427C29.0987 34.0427 34.0427 29.0987 34.0427 23C34.0427 16.9013 29.0987 11.9573 23 11.9573C16.9013 11.9573 11.9573 16.9013 11.9573 23C11.9573 29.0987 16.9013 34.0427 23 34.0427Z",
    fill: "#323F53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 23L18.6243 18.6241C19.8327 17.4157 21.2913 16.8115 23.0001 16.8115V23Z",
    fill: "#842B7C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.0001H16.8115C16.8115 21.2913 17.4157 19.8327 18.6241 18.6243L23 23.0001Z",
    fill: "#645BA7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23L18.6241 27.3758C17.4157 26.1674 16.8115 24.7088 16.8115 23H23Z",
    fill: "#338ECB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 23V29.1884C21.2913 29.1884 19.8327 28.5842 18.6243 27.3758L23.0001 23Z",
    fill: "#58C5C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23L27.3758 27.3758C26.1674 28.5842 24.7088 29.1884 23 29.1884V23Z",
    fill: "#C8202D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23H29.1884C29.1884 24.7088 28.5842 26.1674 27.3758 27.3758L23 23Z",
    fill: "#D06D2B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.0001L27.3758 18.6243C28.5842 19.8327 29.1884 21.2913 29.1884 23.0001H23Z",
    fill: "#FBBE18"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23V16.8115C24.7088 16.8115 26.1674 17.4157 27.3758 18.6241L23 23Z",
    fill: "#F9E700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo_sm.c35750a2e49f798eb904b4e8f39f6524.svg";
export { ForwardRef as ReactComponent };